export default {
  rankOrder: {
    ariaAddOption: 'Ajouter {label} à la liste classée',
    ariaMoveUp: 'Monter {label}',
    ariaMoveDown: 'Descendre {label}',
    ariaRemoveOption: 'Supprimer {label} de la liste classée',
  },
  coe: {
    ariaDisclaimer: 'Avertissement',
    ariaQuestion: 'Question',
    ariaConversationHistory: 'Historique de conversation',
    ariaYourResponse: 'Votre réponse {number}',
    ariaFollowUpQuestion: 'Question de suivi {number}',
    ariaResponseInput: 'Champ de réponse',
    ariaRespondingTo: 'Répondre à',
    ariaSendResponse: 'Envoyer la réponse',
    ariaThinking: 'Réflexion'
  },
  deviceView: {
    toolbar: 'Appareil de prévisualisation',
    mobile: 'Mobile',
    tablet: 'Tablette',
    desktop: 'Bureau'
  },
  header: {
    customLogoAlt: 'Logo',
    defaultLogoAlt: 'Logo QuestDIY'
  }
}
